import React from 'react'
import ClientSetup from '../../admin/ClientSetup'
import V3ProfileRouteShell from '../profile/V3ProfileRouteShell'

export default function V3ClientSetupPage() {
  return (
    <V3ProfileRouteShell>
      <ClientSetup />
    </V3ProfileRouteShell>
  )
}

